<template>
    <v-layout column class="datatable">
        <v-data-table
                :pagination.sync="pagination"
                :must-sort="true"
                :rows-per-page-items="[12, 25, 50]"
                :headers="headers"
                :items="items"
                :total-items="pagination.totalItems"
                v-bind="$attrs"
                :select-all="selectAll"
                v-model="selected">
            <tr slot="items" slot-scope="r">
                <td v-if="selectAll">
                    <v-checkbox
                            v-model="r.selected"
                            primary
                            hide-details
                    ></v-checkbox>
                </td>
                <slot name="items" :item="r.item"></slot>
            </tr>
            <v-layout class="carregando" slot="footer" v-show="loading" row justify-center align-center>
                <v-progress-circular class="ma-2" color="primary" :size="18" :width="2" indeterminate></v-progress-circular>
                Carregando...
            </v-layout>
        </v-data-table>
        <div class="overlay" v-show="loading"></div>
    </v-layout>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  props: { 'url': String, 'params': Object, 'headers': Array, 'filter': Object, 'selectAll': Boolean, 'sort-by': String, 'descending': Boolean },
  data: () => ({
    loading: false,
    pagination: {},
    items: [],
    selected: []
  }),
  created () {
    this.pagination = {
      sortBy: this.sortBy,
      descending: this.descending
    }
  },
  watch: {
    deep: true,
    pagination () {
      this.reload()
    },
    filter () {
      this.reload()
    },
    selected () {
      this.$emit('input', this.selected)
    },
    params () {
      this.reload()
    },
    id_unidade_negocio () {
      this.reload()
    }
  },
  computed: {
    ...mapState(['id_unidade_negocio'])
  },
  methods: {
    reload () {
      Vue.nextTick(() => {
        this.$http.cancel(this._uid)
        this.loading = true
        return this.$http.get(this.url, {
          requestId: this._uid,
          params: { ...this.params, id_unidade_negocio: this.id_unidade_negocio, pagination: this.pagination, filter: this.filter },
          options: { silent: true }
        }).then((res) => {
          this.items = res.data.items
          this.pagination.totalItems = res.data.total
        }).catch(() => {
          // cancel
        }).finally(() => (this.loading = false))
      })
    }
  }
}
</script>

<style scoped>
    .datatable {
        position: relative;
        z-index: 1;
    }

    .carregando {
        position: absolute;
        bottom: 15px;
        z-index: 3;
    }

    .overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 2;
        user-select: none;
        background: #ffffff55;
    }
</style>
